export const ttCss = `
:root{
  --ttp-bg:#ffffff;
  --ttp-text:#111827;
  --ttp-muted:#6b7280;
  --ttp-border:#e5e7eb;
  --ttp-soft:rgba(0,0,0,0.03);
  --ttp-link:#2563eb;
}
.dark :root{
  --ttp-bg:#0a0a0a;
  --ttp-text:#e5e7eb;
  --ttp-muted:#9ca3af;
  --ttp-border:#262626;
  --ttp-soft:rgba(255,255,255,0.06);
  --ttp-link:#60a5fa;
}

/* Card shell */
.ttp-container{max-width:672px;margin:0 auto;padding:24px 16px;}
.ttp-card{
  background:var(--ttp-bg);
  border:1px solid var(--ttp-border);
  color:var(--ttp-text);
  border-radius:12px;
  box-shadow:0 1px 2px rgba(0,0,0,.06);
  overflow:hidden;
}

/* Header */
.ttp-header{display:flex;align-items:center;gap:12px;padding:12px 16px;}
.ttp-avatar{width:44px;height:44px;border-radius:999px;object-fit:cover;flex:0 0 auto;}
.ttp-header-main{min-width:0;flex:1 1 auto;}
.ttp-name-row{display:flex;align-items:center;gap:8px;min-width:0;}
.ttp-name{font-weight:600;text-decoration:none;color:inherit;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;}
.ttp-name:hover{text-decoration:underline;}
.ttp-handle{color:var(--ttp-muted);white-space:nowrap;}
.ttp-dot{color:var(--ttp-muted);}
.ttp-when{color:var(--ttp-muted);white-space:nowrap;}
.ttp-sub{font-size:12px;color:var(--ttp-muted);margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ttp-follow{
  border:0;border-radius:999px;padding:6px 12px;
  background:#fe2c55;color:#fff;cursor:pointer;font-weight:600;
}
.ttp-follow:hover{filter:brightness(0.95);}

/* Media: 9:16 container */
.ttp-media-wrap{background:var(--ttp-soft);}
.ttp-aspect{position:relative;width:100%;aspect-ratio:9/16;background:#000;}
.ttp-media{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}

/* Caption & tags */
.ttp-caption{padding:10px 16px 4px 16px;line-height:1.35;white-space:pre-line;word-wrap:break-word;}
.ttp-mentions{padding:0 16px 0 16px;display:flex;gap:8px;flex-wrap:wrap;}
.ttp-mention{color:var(--ttp-link);cursor:pointer;}
.ttp-mention:hover{text-decoration:underline;}

.ttp-tags{padding:6px 16px 0 16px;display:flex;flex-wrap:wrap;gap:6px 10px;font-size:14px;color:#1d4ed8;}
.dark .ttp-tags{color:#60a5fa;}
.ttp-tag{text-decoration:none;word-break:break-all;}
.ttp-tag:hover{text-decoration:underline;}

.ttp-link{color:var(--ttp-link);text-decoration:underline;word-break:break-all;}
.ttp-link-note{padding:6px 16px 0 16px;font-size:12px;color:var(--ttp-muted);}

/* Counters */
.ttp-counters{
  padding:8px 16px;
  display:flex;flex-wrap:wrap;gap:10px 16px;
  font-size:14px;color:var(--ttp-muted);
  border-top:1px solid var(--ttp-border);
}

/* Actions */
.ttp-actions{display:flex;justify-content:space-around;padding:8px 8px 12px 8px;border-top:1px solid var(--ttp-border);}
.ttp-action{
  display:inline-flex;align-items:center;gap:8px;
  background:transparent;border:0;border-radius:10px;
  color:var(--ttp-text);cursor:pointer;padding:8px 10px;
  font-weight:500;
}
.ttp-action:hover{background:var(--ttp-soft);}
.ttp-icon{width:22px;height:22px;fill:currentColor;color:currentColor;}
`;
